import React, { Component } from 'react'
import { checkNullAndReturnString } from '../helper/common';

class index extends Component {
    render() {
        var { selected, json, tabOnClick } = this.props;
        var content = [];
        if (checkNullAndReturnString(json)) {
            Object.keys(json).forEach(key => {
                content.push(
                    <li className={selected === key ? 'selected' : ''} onClick={() => tabOnClick(key)}>
                        {json[key]}
                    </li>
                )
            })
        }
        return (
            <ul className="inline">
                {content}
            </ul>
        )
    }
}
export default index;